
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/podcast/[playlists]/[podcasts]",
      function () {
        return require("private-next-pages/podcast/[playlists]/[podcasts].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/podcast/[playlists]/[podcasts]"])
      });
    }
  